import { useKeenSlider } from 'keen-slider/react';
import * as React from 'react';

import SurveyNavButton from '../SurveyNavButton';
import Text from '../../../../text/Text.jsx';

export type SurveyStartTeaserProps = {
  topline: React.ReactNode;
  prevButtonTitle: string;
  nextButtonTitle: string;
  children: React.ReactNode;
};

const SurveyStartTeaser = ({
  topline,
  prevButtonTitle,
  nextButtonTitle,
  children
}: SurveyStartTeaserProps) => {
  const multipleSlides = React.Children.count(children) > 2;
  const [sliderRef, instanceRef] = useKeenSlider({
    loop: multipleSlides
  });

  React.useLayoutEffect(() => {
    instanceRef.current?.update();
  }, [children]);

  return (
    <div className="survey-start-teaser">
      <Text className="survey-start-teaser__topline" variant="copy" tag="h4">
        {topline}
      </Text>

      <div className="survey-start-teaser__slider keen-slider" ref={sliderRef}>
        {children}
      </div>

      {multipleSlides && (
        <>
          <div className="survey-start-teaser__prev">
            <SurveyNavButton
              iconId="btn-prev"
              title={prevButtonTitle}
              onClick={() => instanceRef.current?.prev()}
            />
          </div>

          <div className="survey-start-teaser__next">
            <SurveyNavButton
              iconId="btn-next"
              title={nextButtonTitle}
              onClick={() => instanceRef.current?.next()}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default SurveyStartTeaser;
